'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  apiHost: process.env.APIHOST || 'localhiration',
  apiPort: process.env.APIPORT,
  app: {
    title: 'Project Dieu',
    description: 'Create your Resume online',
    head: {
      titleTemplate: 'Online Resume Builder %s: Create Resume within minutes',
      meta: [{ name: 'description', content: 'Use Online Resume Builder by Hiration to build your job winning resume within minutes. Choose from 20+ Resume Designs and 50+ Content Templates.' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Hiration' }, { property: 'og:image', content: 'https://www.hiratio.com/static/favicon.ico' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Project Dieu' }, { property: 'og:description', content: 'Hiration presents Online Resume Maker.' }, { property: 'og:card', content: 'summary' }, { property: 'og:site', content: '@parth-choudhary' }, { property: 'og:creator', content: '@parth-choudhary' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    }
  }

}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 294
// module chunks = 0